import { render, staticRenderFns } from "./OptView.vue?vue&type=template&id=6f3702e3&"
import script from "./OptView.vue?vue&type=script&lang=js&"
export * from "./OptView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports